import React, { Component } from "react";
import { Link } from "react-router-dom";

export class Header extends Component {
    componentDidMount() {}
    render() {
        return (
            <div className="header">
                <div className="header-body">
                    <div className="row align-items-center">
                        <div className="col">
                            <h1 className="header-title">{this.props.title}</h1>

                            <h6 className="header-pretitle">
                                {this.props.subTitle}
                            </h6>
                        </div>
                    </div>
                    <div className="row align-items-center">
                        <div className="col">
                            <ul
                                id="dataFilter"
                                className="nav nav-tabs nav-overflow header-tabs"
                            >
                                <li className="nav-item">
                                    <Link
                                        to={`/employer/billing`}
                                        className={
                                            this.props.match.path ===
                                            "/employer/billing"
                                                ? "nav-link active"
                                                : "nav-link"
                                        }
                                    >
                                        Billing history
                                    </Link>
                                </li>

                                <li className="nav-item">
                                    <Link
                                        to={`/employer/paymentMethod`}
                                        className={
                                            this.props.match.path ===
                                            "/employer/paymentMethod"
                                                ? "nav-link active"
                                                : "nav-link"
                                        }
                                    >
                                        Payment method
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/employer/billing/Header.js